module.exports = __webpack_public_path__ + "static/media/prayers.ed00001a.jpg";